var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMision(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_10863",
    "data-name": "Group 10863",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 68.291,
    height: 61.919,
    viewBox: "0 0 68.291 61.919",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3954",
    "data-name": "Rectangle 3954",
    width: 68.291,
    height: 61.919,
    fill: "#fff",
    stroke: "#fda421",
    strokeWidth: 0.5
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9723",
    "data-name": "Group 9723",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33153",
    "data-name": "Path 33153",
    d: "M68.291,161.185a2.692,2.692,0,0,1-2.6,1.084q-32-.034-64,0a1.642,1.642,0,0,1-1.43-2.52,1.6,1.6,0,0,1,1.451-.689c2.4-.017,4.8-.007,7.2-.008h.715V158.3q0-9.467-.006-18.934a1.512,1.512,0,0,1,1.6-1.64q4.767-.026,9.533,0a1.712,1.712,0,0,1,1.755,1.9c.017.889,0,1.778,0,2.667V159h5.219v-.724c0-8.756.023-17.512-.021-26.267-.008-1.558.793-2.133,2.1-2.108,2.91.056,5.822.016,8.733.018,1.456,0,2.039.578,2.039,2.02q0,13.167,0,26.334v.745h5.219v-.794q0-17.2-.016-34.4a1.714,1.714,0,0,1,1.695-1.723c3.089.023,6.179-.03,9.267.027,1.312.024,1.932.426,1.934,2.108q.019,14.3.006,28.6v6.181c.208.011.4.03.591.03,2.245,0,4.489.016,6.734-.005a2.191,2.191,0,0,1,2.287,1.207Zm-55.447-2.269.106.113h6.331V140.937H12.95l-.107.113Zm42.617,0c.006-.244.018-.488.018-.732q0-16,0-32c0-.244-.012-.488-.018-.732l-.106-.113H49.022v33.695h6.331l.107-.113M37.332,133.153H30.961v25.875h6.372Z",
    transform: "translate(0 -100.349)",
    fill: "#fff",
    stroke: "#fda421",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33154",
    "data-name": "Path 33154",
    d: "M99.065,6.424q-1.4,1.53-2.795,3.06c-.418.455-.839.909-1.274,1.348-1.313,1.325-2.579,2.706-3.966,3.949-1.887,1.69-3.822,3.334-5.824,4.884-2.19,1.7-4.437,3.326-6.736,4.87A83.634,83.634,0,0,1,66.812,31a86.108,86.108,0,0,1-11.029,4.255,2.039,2.039,0,0,1-1.811.035,1.572,1.572,0,0,1-.756-1.661,1.424,1.424,0,0,1,1-1.219c3.48-1.274,7-2.466,10.4-3.92a73.083,73.083,0,0,0,11.4-6.161c2.2-1.446,4.374-2.94,6.488-4.509,1.489-1.105,2.886-2.341,4.272-3.577,1.76-1.568,3.537-3.128,5.181-4.815,1.9-1.95,3.664-4.035,5.563-6.146-.263-.026-.422-.055-.582-.055-1.955,0-3.91,0-5.865,0a1.487,1.487,0,0,1-1.6-1.444C89.434.715,89.944.048,90.954.038c3.221-.032,6.445-.074,9.663.019,1.247.036,1.713.39,1.752,1.789.087,3.086.051,6.176.017,9.264a1.621,1.621,0,0,1-2.459,1.6A1.308,1.308,0,0,1,99.2,11.5q-.014-2.532-.032-5.063l-.013-.106-.094.1",
    transform: "translate(-43.716 -0.001)",
    fill: "#fff",
    stroke: "#fda421",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33155",
    "data-name": "Path 33155",
    d: "M310.7,328.855l.107-.113-.107.113",
    transform: "translate(-255.351 -270.175)",
    fill: "#fff",
    stroke: "#fda421",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMision);
export default __webpack_public_path__ + "static/media/mision.9a66262ec69848fa3f9f198a76e7b059.svg";
export { ForwardRef as ReactComponent };